import {createMutation} from '@/utils/common.js'

const store = {
  namespaced: true,
  state:() => {
    return {
      visible: false,
      linkinUrl: '',
      message: '您即将离开海智智造，需登录您的海外领英账号进行访问，请确保您的访问环境',
    }
  },
}

store.mutations = createMutation(store.state())

export default store